export enum ShipmentsListType {
  All = 'all',
  MyShipemnts = 'my-shipments',
  Backhaul = 'backhaul',
}
